"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgZoomMeeting = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_ZOOM-MEETING", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "m13.022 11.201 1.479 1.247c.363.306.544.459.69.495a.65.65 0 0 0 .743-.352c.066-.137.066-.375.066-.853V5.327c0-.478 0-.717-.066-.854a.65.65 0 0 0-.743-.352c-.146.037-.327.19-.69.495l-1.48 1.248c-.24.203-.361.304-.458.42a1.739 1.739 0 0 0-.377.815c-.026.15-.026.308-.026.626V9.34c0 .318 0 .476.026.626.053.3.183.581.377.814.097.116.218.218.459.421ZM0 5.712c0-.6 0-.899.115-1.128.102-.201.263-.365.462-.467C.804 4 1.1 4 1.692 4H7.09c1.55 0 2.326 0 2.919.305.52.269.945.698 1.21 1.225.302.6.302 1.384.302 2.953v2.87c0 .599 0 .899-.115 1.127a1.063 1.063 0 0 1-.462.468c-.227.117-.523.117-1.115.117H4.43c-1.55 0-2.326 0-2.919-.306a2.785 2.785 0 0 1-1.21-1.224C0 10.935 0 10.15 0 8.582v-2.87Z" }))); };
exports.default = SvgZoomMeeting;
